import { $api } from '@service/RequestService';
import { InfiniteData, useMutation, useQueryClient } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useTagSave = (props: { onSuccess?: (data: crmModels.ITags['tagList'][number]) => void } = {}) => {
  const qc = useQueryClient();

  return useMutation<crmModels.ITags['tagList'][number], any, crmModels.ITags['tagList'][number]>(
    async data => {
      const res = await $api.post('/v1/tag', data);

      return res?.data?.data;
    },
    {
      onSuccess: async tagData => {
        await qc.invalidateQueries([crmConstants.queryKeys.TAG_ALL]);
        qc.invalidateQueries([crmConstants.queryKeys.LEAD_FILTER_PARAMS]);
        qc.setQueriesData(
          [crmConstants.queryKeys.LEAD_FILTER_V2],
          (data: InfiniteData<crmModels.ILeadFilterV2> | undefined) =>
            ({
              ...data,
              pages: data?.pages.map(item => ({
                ...item,
                leadList: {
                  ...item.leadList,
                  data: item.leadList.data.map(lead => ({
                    ...lead,
                    tags: lead?.tags?.map(tag => ({
                      ...tag,
                      ...(tag?.id === tagData?.id && { color: tagData?.color })
                    }))
                  }))
                }
              }))
            }) as any
        );
        if (props?.onSuccess) {
          props?.onSuccess(tagData);
        }
      }
    }
  );
};
